import { BsModalRef } from 'ngx-bootstrap/modal'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import moment from 'moment-mini'
import { EmployeeContract } from '../../employee-contract/employee-contract'
import { Observable, of } from 'rxjs'
import { employeeContractSelectors } from '../../employee-contract/employee-contract.selectors'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { Dictionary } from '@ngrx/entity'
import { employeeContractActions } from '../../employee-contract/employee-contract.actions'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CalendarCheckedDateModalComponent implements OnInit {
  @Output() calendarCheckedDate: EventEmitter<any> = new EventEmitter()
  @Input() contractIds: number[]
  public form: UntypedFormGroup
  public currentCalendarCheckedDate = null
  public contracts: EmployeeContract[] = []
  public contractEntities$: Observable<Dictionary<EmployeeContract>>
  public selectedContractId: number = null
  public calendarCheckedDateIsInPast: boolean = false
  public contracts$: Observable<EmployeeContract[]>

  constructor(
    private fb: UntypedFormBuilder,
    private bsModalRef: BsModalRef,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      calendarCheckedDate: [null, [Validators.required]]
    })

    this.store.dispatch(
      employeeContractActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            id: {
              [CondOperator.IN]: this.contractIds
            }
          }
        })
      })
    )

    this.contractEntities$ = this.store.select(
      employeeContractSelectors.selectEntities
    )

    this.contractEntities$
      .pipe(untilDestroyed(this))
      .subscribe((contractEntities) => {
        this.contractIds.forEach((contractId) => {
          // if (!this.contracts.includes(contractEntities[contractId])) {
          if (
            !this.contracts.length ||
            this.contracts.some((contract) => contract.id != contractId)
          ) {
            this.contracts.push(contractEntities[contractId])
          }
        })
      })

    if (this.contractIds?.length == 1) {
      this.selectedContractId = this.contractIds[0]
      this.onChangeContract()
    }

    this.form.controls.calendarCheckedDate.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((calendarCheckedDate) => {
        this.calendarCheckedDateIsInPast = false
        if (
          this.currentCalendarCheckedDate &&
          moment(calendarCheckedDate).isBefore(
            moment(this.currentCalendarCheckedDate)
          )
        ) {
          this.calendarCheckedDateIsInPast = true
        }
      })
    this.contracts$ = of(this.contracts)
  }

  public onChangeContract() {
    this.contractEntities$
      .pipe(untilDestroyed(this))
      .subscribe(
        (contractEntities) =>
          (this.currentCalendarCheckedDate =
            contractEntities[this.selectedContractId]?.checkedTillDate)
      )
  }

  public onFormSubmit() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })
      return
    }

    this.calendarCheckedDate.next({
      contractId: Number(this.selectedContractId),
      date: moment(this.form.value.calendarCheckedDate).startOf('day')
    })
    this.cancel()
  }

  public cancel() {
    this.bsModalRef.hide()
  }
}
